import React from "react"

class Timer extends React.Component {
    timerInterval = null;
    state = {
        total: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    }
    componentDidMount = () => {
        this.timerInterval = setInterval(()=> {
            const timeElapsed = this.getTimeElapsed();
            this.setState(timeElapsed);
        }, 1000)
    }

    componentWillUnmount = () => {
        clearInterval(this.timerInterval)
    }

    getTimeElapsed = () => {
        const timeFrom = this.props.from;
        if(timeFrom != null){
            const t = new Date().getTime() - timeFrom;
            return {
              'total': t,
              'days': Math.floor( t/(1000*60*60*24) ),
              'hours': Math.floor( (t/(1000*60*60)) % 24 ),
              'minutes': Math.floor( (t/1000/60) % 60 ),
              'seconds': Math.floor( (t/1000) % 60 )
            };
        } else 
            return null;
    }

    render() {
        
        return <React.Fragment>
            <span>{this.state.hours} : {this.state.minutes} : {this.state.seconds}</span>
        </React.Fragment>
    }
}
export default Timer;
